
import React from "react";

  const BrandSelection = ({locale}) => {

    const dictionary = {	
      en: {
        "drop-down-please-select-label": "Please select",
        "sunwing-vacations": "Sunwing",
        "westjet-vacations":"WestJet Vacations",
        "westjet-vacations-quebec": "WestJet Vacations Quebec",
        "brand": "Brand",
        "please-select-brand": "Please select brand."
      },
      fr:{
        "drop-down-please-select-label": "Veuillez sélectionner",
        "sunwing-vacations": "Sunwing",
        "westjet-vacations":"Vacances à WestJet",
        "westjet-vacations-quebec": "Vacances WestJet Québec",
        "brand": "Marque",
        "please-select-brand": "Veuillez sélectionner la marque."
      }
    }

  const handleBrandChange = (e) => {

    const signinBrandError = document.getElementById("signin-brand-error");
    const signinBrandSelectElement = document.getElementById("signin-brand-selector");
    const hasSelectedBrand = e.target.value.length > 0;

    sessionStorage.setItem("selected-brand", e.target.value);

    if(hasSelectedBrand) {
      signinBrandError.style.display = "none";
      signinBrandSelectElement.style.borderColor = "#bbb";
    }
  };

  return (
    <>
      <div data-se="o-form-label" class="okta-form-label o-form-label">
        <label for="okta-signin-brand">{dictionary[locale]["brand"]}&nbsp;</label>
      </div>
      <div data-se="o-form-input-container">
        <select 
          id="signin-brand-selector"
          class="o-form-input-name-username o-form-control okta-form-input-field input-fix" 
          name="selectedBrand" 
          onChange={(e) => handleBrandChange(e)}
          defaultValue="" >
          <option value="">{dictionary[locale]["drop-down-please-select-label"]}</option>
         <option value="swg">{dictionary[locale]["sunwing-vacations"]}</option>
          <option value="wvi">{dictionary[locale]["westjet-vacations"]}</option>
          <option value="vwq">{dictionary[locale]["westjet-vacations-quebec"]}</option>
        </select>
      </div>
      <div class="o-form-input-error" id="signin-brand-error" style={{display:'none'}}>
          <label style={{color: '#B00121'}}>
            {dictionary[locale]["please-select-brand"]}
          </label> 
      </div>
    </>
  );
}

export default BrandSelection;